import React from 'react';

const PayloadDescription = ({ type }) => {
    if (type === 'original') {
        return (
            <div>
                <ul>
                    <li>
                        <strong>betBuilders</strong>{' '}
                        <i>
                            - an array of betBuilders containing selectedOdds
                            values (decimal, american, fractional) and
                            selectedOutcomeIds for betBuilder bets.
                            <br />
                            <strong>Note:</strong> the betBuilders list should
                            contain only betbuilders related to betslip
                            selection. Meaning that the onDemandPricing can
                            retrun all possible betBuilders, we only need the
                            ones related to betslip selection.
                        </i>
                    </li>
                    <li>
                        <strong>betOffers</strong>
                        <i>
                            {' '}
                            - an array of betOffers containing betOffer id and
                            eachWay info. EachWay is related to racing bets.
                        </i>
                    </li>
                    <li>
                        <strong>hasSelectedTeaser</strong>{' '}
                        <i>
                            {' '}
                            - boolean value reflecting if teaser is selected for
                            current betslip selection. In this case, the stake
                            with type <strong>teaser</strong> will be used to
                            calculate the payout and selectedTab needs to have{' '}
                            <strong>combination</strong> value.
                        </i>
                    </li>
                    <li>
                        <strong>
                            selectedOutcomes<sup>*</sup>
                        </strong>{' '}
                        <i>
                            {' '}
                            - an array of selected outcomes containing id
                            <sup>*</sup>, odds<sup>*</sup>, nrOfPermutations,
                            betOfferId.
                        </i>
                        <ul>
                            <li>
                                <u>nrOfPermutations</u> is used for
                                multiPosition bets
                            </li>
                        </ul>
                    </li>
                    <li>
                        <strong>selectedReward</strong>{' '}
                        <i>
                            - an object containing information about the
                            selected reward. Depending on the reward type, the
                            information must be provided in pairs. E.g.:
                            (isOddsBoost & boostedOdds), (isProfitBoost &
                            boostPercentage), (isFreeBet & freeBetAmount).
                        </i>
                    </li>
                    <li>
                        <strong>
                            selectedTab<sup>*</sup>
                        </strong>{' '}
                        <i>
                            - a string containing the <strong>betslip</strong>{' '}
                            selected tab. Possible values are: single &
                            combination. Depending on the selectedTab value, the
                            stakes array is filtered by type and used to
                            calculate the potentialPayout
                        </i>
                    </li>
                    <li>
                        <strong>
                            stakes<sup>*</sup>
                        </strong>{' '}
                        <i>
                            - an array containing information about stakes in
                            betslip. The object contains stake<sup>*</sup>,
                            outcomeId, toWinInput, stakeInput, eachWaySelected
                            and type<sup>*</sup>.
                        </i>
                        <ul>
                            <li>
                                <u>
                                    stake<sup>*</sup>
                                </u>{' '}
                                - represents the stake value in mili format
                                (e.g.: 1 in mili is 1000)
                            </li>
                            <li>
                                <u>stakeInput</u> - represents the stake value
                                'readable' format (e.g.: 10)
                            </li>
                            <li>
                                <u>
                                    type<sup>*</sup>
                                </u>{' '}
                                - can be{' '}
                                <i>single, combination, system, teaser</i>
                            </li>
                        </ul>
                    </li>
                </ul>
                <p>
                    <i>
                        <sup>*</sup>required
                    </i>
                </p>
            </div>
        );
    }

    if (type === 'system') {
        return (
            <div>
                <ul>
                    <li>
                        <strong>
                            hasBetErrors<sup>*</sup>
                        </strong>{' '}
                        <i>
                            {' '}
                            - boolean that should be sent as true only if the
                            selectedOutcomes have any bet errors. In this case
                            the return value will be the string defined in
                            translations.payoutNotAvailableTranslation property.
                        </i>
                    </li>
                    <li>
                        <strong>
                            hasBetBuilders<sup>*</sup>
                        </strong>{' '}
                        <i>
                            {' '}
                            - boolean that should be sent as true only if there
                            is a bet builder active and the player is on the
                            combination tab. In this case the return value will
                            be the string defined in
                            translations.payoutNotAvailableTranslation property.
                        </i>
                    </li>
                    <li>
                        <strong>translations</strong>{' '}
                        <i>
                            {' '}
                            - an object that should contain another object with
                            key payoutNotAvailableTranslation and as value the
                            translation text that will be shown if there are bet
                            errors or there any bet builders. If translation
                            object is not passed as argument the return value
                            will be "N/A".
                        </i>
                    </li>
                    <li>
                        <strong>
                            selectedOutcomes<sup>*</sup>
                        </strong>{' '}
                        <i>
                            {' '}
                            - an array of selected outcomes containing id
                            (outcomeId)
                            <sup>*</sup>, odds<sup>*</sup>, nrOfPermutations,
                            betOfferId.
                        </i>
                        <ul>
                            <li>
                                <u>nrOfPermutations</u> is used for
                                multiPosition bets
                            </li>
                        </ul>
                    </li>
                    <li>
                        <strong>
                            stakes<sup>*</sup>
                        </strong>{' '}
                        <i>
                            - an array containing information about stakes in
                            betslip. The object contains stake<sup>*</sup>,
                            outcomeId, toWinInput, stakeInput, eachWaySelected
                            and systemType<sup>*</sup>.
                        </i>
                        <ul>
                            <li>
                                <u>
                                    stake<sup>*</sup>
                                </u>{' '}
                                - represents the stake value in mili format
                                (e.g.: 1 in mili is 1000)
                            </li>
                            <li>
                                <u>stakeInput</u> - represents the stake value
                                'readable' format (e.g.: 10)
                            </li>
                            <li>
                                <u>
                                    systemType<sup>*</sup>
                                </u>{' '}
                                - can be{' '}
                                <i>
                                    single, double, treble, fourfold, fivefold,
                                    sixfold, sevenfold, eightfold, ninefold,
                                    tenfold, elevenfold, twelvefold
                                </i>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <strong>
                            selectedReward<sup>*</sup>
                        </strong>{' '}
                        <i>
                            - an object containing information about the
                            selected reward. Depending on the reward type, the
                            information must be provided in pairs. E.g.:
                            (isOddsBoost & boostedOdds), (isProfitBoost &
                            boostPercentage), (isFreeBet & freeBetAmount).
                        </i>
                    </li>
                    <li>
                        <strong>
                            betOffers<sup>*</sup>
                        </strong>
                        <i>
                            {' '}
                            - an array of betOffers containing betOffer id and
                            eachWay info (an object with fractionMilli
                            property). EachWay is related to racing bets.
                        </i>
                    </li>
                </ul>
                <p>
                    <i>
                        <sup>*</sup>required
                    </i>
                </p>
            </div>
        );
    }

    return '';
};

export default PayloadDescription;
